import React from "react";

import { User } from "cortex/ui/src/user/model";

import { NavBar } from "./NavBar";

interface NavigationProps {
  hideSettings?: boolean;
  user: User;
}

export function Navigation({ hideSettings, user }: NavigationProps) {
  return <NavBar hideSettings={hideSettings} user={user} />;
}
